import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payment-method-debug")({
  component: lazyRouteComponent(() => import("./-pages/admin.payment-method-debug")),
  head: () => ({ meta: [{ title: "Admin · Payment Method Debug — Lecmo" }] }),
});
